import React from 'react';
import {
  AreaChart,
  Area,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from 'recharts';

interface NetWorthPoint {
  label: string;
  value: number;
}

interface Props {
  data: NetWorthPoint[];
}

const DashboardNetWorthChart: React.FC<Props> = ({ data }) => {
  return (
    <div className="bg-white p-4 rounded-xl shadow border">
      <div className="flex justify-between items-center mb-2">
        <p className="text-md text-gray-700">
          <span className="text-blue-600 font-bold text-lg">-$8,919 net worth</span>{' '}
          <span className="text-green-600 text-sm font-medium">↑ $925.02 (9.4%)</span>
        </p>
        <select className="border border-gray-300 rounded px-2 py-1 text-sm text-gray-700">
          <option>1 month</option>
          <option>3 months</option>
          <option>6 months</option>
        </select>
      </div>

      <ResponsiveContainer width="100%" height={250}>
        <AreaChart
          data={data}
          margin={{ top: 10, right: 30, left: 0, bottom: 30 }}
        >
          <CartesianGrid strokeDasharray="3 3" stroke="#e5e7eb" />
          <XAxis
            dataKey="label"
            tick={{ fontSize: 12, fill: '#6b7280' }}
          />
          <YAxis
            tickFormatter={(v) => `-$${Math.abs(v)}`}
            tick={{ fontSize: 12, fill: '#6b7280' }}
          />
          <Tooltip
            formatter={(v: any) => `-$${Math.abs(v)}`}
            labelStyle={{ fontWeight: 'bold', color: '#111827' }}
            contentStyle={{ backgroundColor: '#fff', borderRadius: 6, border: '1px solid #e5e7eb' }}
          />
          <Area
            type="stepAfter"
            dataKey="value"
            stroke="#0ea5e9"
            fill="#bae6fd"
            strokeWidth={3}
            dot={false}
          />
        </AreaChart>
      </ResponsiveContainer>
    </div>
  );
};

export default DashboardNetWorthChart;
